import * as React from 'react';
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';
import { TextBox } from "@progress/kendo-react-inputs";
import { Label } from '@progress/kendo-react-labels';
import configData from "../config.json";
import { GetToken } from '../components/Session';
import { Button } from '@progress/kendo-react-buttons';

export const Induction = (props) => {

    const [rego, setRego] = React.useState(props.rego);
    const playlist = props.playlist;
    const dispTimer = React.useRef(null);
    const [textEntryType, setTextEntryType] = React.useState();
    const keyboard = React.useRef();
    const playlists = React.useRef();
    const [text, setText] = React.useState(rego);
    const [question, setQuestion] = React.useState("");
    const [image, setImage] = React.useState("");
    const [ans1, setAns1] = React.useState("");
    const [ans2, setAns2] = React.useState("");
    const [ans3, setAns3] = React.useState("");
    const [ans4, setAns4] = React.useState("");
    const [ans5, setAns5] = React.useState("");
    const playlistNo = React.useRef(0);
    const questionNo = React.useRef(0);
    const isCorrect = React.useRef(false);
    const isWrong = React.useRef(false);
    const isPrompt = React.useRef(false);
    const correctAnswer = React.useRef(0);
    const numWrong = React.useRef(0);
    const numCorrect = React.useRef(0);
    const answers = React.useRef("");

    const [layout, setLayout] = React.useState({
        'default': [
            '1 2 3 4 5 6 7 8 9 0 {bksp}',
            'Q W E R T Y U I O P',
            'A S D F G H J K L {enter}',
            '{shift} Z X C V B N M {clear}',
            '{space}'
        ]
    });
    const display = {
        '{bksp}': 'Back',
        '{enter}': 'Enter',
        '{space}': 'Space',
        '{clear}': 'Clear',
        '{shift}': 'Shift'
    }
    React.useEffect(() => {
        if (rego === undefined || rego === "")
            setTextEntryType("Rego");
        else
            CheckInductions(rego);

        return () => { // kill any timers when leaving page
            if (dispTimer.current !== null) clearTimeout(dispTimer.current);
        }
    }, [props.content]);

    const onChange = (ev) => { setText(ev); }

    const KeyPressed = (k) => {
        switch (k) {
            case "{clear}":
                setText("");
                if (keyboard.current !== undefined) keyboard.current.setInput("");
                break;
            case "{bksp}":
                if (text.length > 0) setText(text.substring(0, text.length - 1));
                break;
            case "{enter}":
                setRego(text);
                CheckInductions(text);
                break;
        }
    }
    const TextboxChanged = (ev) => { setText(ev.value); }

    const KeyPress = (ev) => { if (ev.charCode === 13 && props.textEntered) props.textEntered(text); }

    const CheckInductions = (rego) => {
        setTextEntryType();
        var url = configData.SERVER_URL + `clientapi/weighbridge/getinductions?rego=${rego}`;
        if (playlist !== undefined) url += `&playlist=${playlist}`;
        const init = {
            method: 'GET',
            accept: 'application/json',
            headers: { "Authorization": "Bearer " + GetToken() }
        }
        fetch(url, init).then(response => response.json()).then(d => {
            if (d === null || d.length === 0 || (d.length === 1 && d[0].questions.length === 0)) {
                if (props.finished) props.finished();
            } else {
                playlists.current = d;
                playlistNo.current = 0;
                questionNo.current = 0;
                isWrong.current = false;
                isCorrect.current = false;
                isPrompt.current = false;
                numCorrect.current = 0;
                numWrong.current = 0;
                answers.current = "Q1:";
                DisplayNextQuestion();
            }
        });
    }

    const DisplayNextQuestion = () => {
        let c = "";
        let pl = playlists.current[playlistNo.current];
        let q = pl.questions[questionNo.current];
        setQuestion(q.questionText);
        setImage(q.questionImage);
        var mp = [0, 1, 2, 3, 4, 5];
        if (pl.randomize) {
            mp = [0];
            let i = 0;
            let n = 1;
            if (q.answer2 !== "") {
                n = 2;
                if (q.answer3 !== "") {
                    n = 3;
                    if (q.answer4 !== "") {
                        n = 4;
                        if (q.answer5 !== "") n = 5;
                    }
                }
            }
            let v = 0, e = 0;
            correctAnswer.current = 0;
            for (i = 1; i <= n; i++) {
                do {
                    v = Math.floor(Math.random() * n) + 1;
                    e = mp.find(obj => { return obj === v });
                    if (e === undefined) {
                        mp.push(v);
                        if (v === q.correctAnswer) correctAnswer.current = mp.length - 1;
                    }
                } while (e !== undefined);
            }
        } else {
            correctAnswer.current = q.correctAnswer;
        }
        setAns1(GetAnswer(q, mp[1]));
        setAns2(GetAnswer(q, mp[2]));
        setAns3(GetAnswer(q, mp[3]));
        setAns4(GetAnswer(q, mp[4]));
        setAns5(GetAnswer(q, mp[5]));
    }

    const GetAnswer = (ans, v) => {
        switch (v) {
            case 1: return ans.answer1;
            case 2: return ans.answer2;
            case 3: return ans.answer3;
            case 4: return ans.answer4;
            case 5: return ans.answer5;
        }
        return "";
    }

    const AnswerSelected = (a) => {
        if (isPrompt.current && isWrong.current && playlists.current[playlistNo.current].mandatory) {
            isCorrect.current = false;
            isWrong.current = false;
            isPrompt.current = false;
            DisplayNextQuestion();
            return;
        }
        if (!isPrompt.current) answers.current += a + " ";
        let pl = playlists.current[playlistNo.current];
        if (isCorrect.current) {
            GoToNext();
            return;
        }
        if (isWrong.current) {
            if (pl.mandatory)
                DisplayNextQuestion();
            else
                GoToNext();
            return;
        }
        if (correctAnswer.current !== a) {
            numWrong.current++;
            if (pl.wrongAnswerMessage !== "") {
                isCorrect.current = false;
                isWrong.current = true;
                isPrompt.current = true;
                DisplayMessage(pl.wrongAnswerMessage);
            } else {
                GoToNext();
            }
        } else {
            numCorrect.current++;
            if (pl.correctAnswerMessage !== "" && pl.questions[questionNo.current].answer2 !== "") {
                isCorrect.current = true;
                isWrong.current = false;
                isPrompt.current = true;
                DisplayMessage(pl.correctAnswerMessage);
            } else {
                GoToNext();
            }
        }
    }

    const GoToNext = () => {
        isCorrect.current = false;
        isWrong.current = false;
        isPrompt.current = false;
        let pl = playlists.current[playlistNo.current];
        let q = pl.questions[questionNo.current];
        if (questionNo.current < pl.questions.length - 1) {
            questionNo.current++;
            answers.current += "\nQ" + questionNo.current + ":";
            DisplayNextQuestion();
            return;
        } else {
            PostResults(numCorrect.current, numWrong.current, answers.current);
            numCorrect.current = 0;
            numWrong.current = 0;
            answers.current = "Q1:";
            if (playlistNo.current < playlists.current.length - 1) {
                playlistNo.current++;

                DisplayNextQuestion();
            } else {
                if (props.finished) props.finished();
            }
        }
    }

    const DisplayMessage = (m) => {
        setQuestion(m);
        setImage("");
        setAns1("Ok");
        setAns2("");
        setAns3("");
        setAns4("");
        setAns5("");
    }

    const PostResults = (correct, wrong, answers) => {
        var url = `${configData.SERVER_URL}apiv7/inductionresults`;
        const init = {
            method: 'POST',
            accept: "application/json",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache",
            body: JSON.stringify({
                "inductionResultId": 0,
                "inductionPlaylistId": playlists.current[playlistNo.current].inductionPlaylistId,
                "driver": rego,
                "lastCorrect": correct,
                "lastWrong": wrong,
                "lastAnswers": answers
            })
        };
        fetch(url, init);
    }

    const GoBack = () => {
        isWrong.current = false;
        isCorrect.current = false;
        isPrompt.current = false;
        let q = questionNo.current - 1;
        if (q < 0) {
            let p = playlistNo.current - 1;
            playlistNo.current = p;
            let pl = playlists.current[p];
            q = pl.questions.length - 1;
        }
        questionNo.current = q;
        DisplayNextQuestion();
   }

    return (
        <div id="Induction">
            {textEntryType !== undefined && <div id="InductionKeyboard">
                <div class="row" style={{ paddingBottom: "30px" }}>
                    <div class="col-md-3">
                        <Label>Rego</Label>
                        <TextBox autoFocus={true} className={"vkEntryTextbox"} placeholder={"Enter rego"} value={text} onChange={TextboxChanged} onKeyPress={KeyPress}></TextBox></div>
                </div>
                <div className={"textKeyboardDiv"}><Keyboard keyboardRef={r => (keyboard.current = r)} onKeyPress={KeyPressed} onChange={onChange} display={display} layout={layout} layoutName="default" /></div>
            </div>}
            {(question || image) && <div className="InductionAnswers">
                {(questionNo.current !== 0 || playlistNo.current !== 0) && <div className="AnswerBack"><Button onClick={GoBack}>Back</Button></div>}
                {question && <div className="QuestionText">{question}</div>}
                {image && <div className="QuestionImageDiv"><img className="QuestionImage" src={image} /></div>}
                <div className="row col-md-11 AnswerButton"><Button onClick={() => AnswerSelected(1)}>{ans1}</Button></div>
                {ans2 && <div className="row col-md-11 AnswerButton"><Button onClick={() => AnswerSelected(2)}>{ans2}</Button></div>}
                {ans3 && <div className="row col-md-11 AnswerButton"><Button onClick={() => AnswerSelected(3)}>{ans3}</Button></div>}
                {ans4 && <div className="row col-md-11 AnswerButton"><Button onClick={() => AnswerSelected(4)}>{ans4}</Button></div>}
                {ans5 && <div className="row col-md-11 AnswerButton"><Button onClick={() => AnswerSelected(5)}>{ans5}</Button></div>}
            </div>}
        </div>
    );
}